import {
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  TextField
} from "@mui/material";
import { useState } from "react";
import NumberFormatWrapper from "./NumberFormatWrapper";
import { useTranslation } from "react-i18next";

const FormControlWrapper = ({
  name,
  value,
  label,
  type,
  maxLength,
  error = "",
  translateError = true,
  theme,
  onChange,
  required,
  disabled,
  multiline,
  rows = 4,
  sx,
  labelSx = {},
  maskNumber,
  autoFocus,
  placeholder,
  endAdornment,
  prefix = "$",
  shrinkLabel,
  size = "medium",
  dataTestId = {
    inputId: null,
    errorId: null,
  },
  formControlSx = {},
  startAdornment = null
}) => {
  const { t } = useTranslation();
  const [focused, setFocused] = useState(false);

  if (multiline) {
    const showLabel = !value || value.trim() === "";

    return (
      <TextField
        fullWidth
        id={name}
        label={showLabel ? label : ""} // hide label once typing starts
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        multiline
        rows={rows}
        error={error !== ""}
        helperText={error ? (translateError ? t(error) : error) : ""}
        variant="outlined"
        required={required}
        disabled={disabled}
        inputProps={{
          maxLength,
          "data-testid": dataTestId?.inputId,
        }}
        sx={{
          ...theme.typography.customInput,
          ...formControlSx,
          ...sx,
        }}
        placeholder={placeholder}
        InputProps={{
          sx: {
            alignItems: 'flex-start',
            '& .MuiInputBase-inputMultiline': {
              lineHeight: 1.6,
              paddingTop: '20px',
            },
          },
        }}
        autoFocus={autoFocus}
      />
    );
  }



  // For normal (single-line) input
  return (
    <FormControl
      fullWidth
      sx={{ ...theme.typography.customInput, ...formControlSx }}
      error={error !== ""}
      required={required}
      disabled={disabled}
      size={size}
    >
      <InputLabel
        htmlFor={name}
        sx={labelSx}
        shrink={
          shrinkLabel ||
          focused ||
          (value && value !== "") ||
          undefined
        }
      >
        {label}
      </InputLabel>
      <OutlinedInput
        id={name}
        type={type}
        label={label}
        inputProps={{
          maxLength,
          "data-testid": dataTestId?.inputId,
        }}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        {...(maskNumber && {
          inputComponent: NumberFormatWrapper,
          inputProps: { prefix },
        })}
        autoFocus={autoFocus}
        // 👇 placeholder only shows when empty
        placeholder={!value ? placeholder : ""}
        endAdornment={endAdornment}
        startAdornment={startAdornment}
        sx={sx}
      />
      {error !== "" && (
        <FormHelperText
          error
          id={`${name}Error`}
          {...(name && { "data-testid": `${name}Error` })}
        >
          {translateError ? t(error) : error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default FormControlWrapper;
